import { render, staticRenderFns } from "./PaymentBreakdown.vue?vue&type=template&id=27780143&scoped=true&"
import script from "./PaymentBreakdown.vue?vue&type=script&lang=js&"
export * from "./PaymentBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./PaymentBreakdown.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PaymentBreakdown.vue?vue&type=style&index=1&id=27780143&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27780143",
  null
  
)

export default component.exports